import styled from 'styled-components';

export const SkeletonContainer = styled.div<{ $isBig?: boolean }>`
    height: ${({ $isBig }) => ($isBig ? '40px' : '25px')};
    border-radius: 4px;
    background-color: ${({ theme }) => theme.Surface.tertiary};
    width: ${({ $isBig }) => ($isBig ? '100%' : '40%')};
    overflow: hidden;
`;
